import {MapCountByLayer} from './Map';
import {Zone} from './Zone';

export const beltAddressMask = 0x0fffff;

type Beacon = {
  nodeID: number;
  rssi: number;
};

type ConfirmMessage = {
  id: number;
  answer: string | null;
  status: string | null;
  message: string | null;
  message_type: number;
  date: string | null;
  date_ack: string | null;
  date_read: string | null;
};

export interface BeltMonitoringNode {
  id: number;
  type: string;
  mc2_flag: boolean | null;
  name: string;
  status: 'active' | 'inactive' | null;
  atest: 0 | 1 | null;
  checked_in: 0 | 1 | null;
  date_checked_in: string | null;
  company_id: number;
  employee_asset_id: number | null;
  external_id: number | null;
  commtrac_external_id: number;
  date: string | null;
  commtrac_date: string | null;
  commtrac_battery_voltage: number | null;
  commtrac_alarm: 0 | 1;
  latitude: number | null;
  longitude: number | null;
  commtrac_error_ellipse_major_radius: number | null;
  commtrac_error_ellipse_minor_radius: number | null;
  commtrac_error_ellipse_orientation: number | null;
  commtrac_beacon_data: Beacon[] | [];
  commtrac_on_surface: number | null;
  zone_id: number | null;
  commtrac_current_zone_name: string | null;
  commtrac_strongest_cn: string | null;
  commtrac_strongest_cn_name: string | null;
  reporting_frequency: number | null;
  acknowledged: 1 | 0;
  checked_out_location_count: number | null;
  activated_at: string | null;
  deactivated_at: string | null;
  location_frequency: number | null;
  cam_monitor_battery: boolean | null;
  has_motion_sensor: boolean | null;
  motion_sensor_value: number | null;
  sensors_number: number | null;
  low_battery_notified: boolean | null;
  sensor: number | null;
  sensor2: number | null;
  units: string | null;
  units2: string | null;
  value: number | null;
  value2: number | null;
  input_bits: string | null;
  output_bits: string | null;
  belt_status: string | null;
  speed: number | null;
  motor1: number | null;
  motor2: number | null;
  inputs: number | null;
  running: number | null;
  run_status: number | null;
  misk_ouput_1_on: boolean | null;
  misk_ouput_2_on: boolean | null;
  misk_ouput_3_on: boolean | null;
  misk_ouput_4_on: boolean | null;
  input_faults: string | null;
  output_faults: string | null;
  output_status: string | null;
  output_status_text: string | null;
  e_601: boolean;
  e_602: boolean;
  e_603: boolean;
  e_604: boolean;
  e_605: boolean;
  e_606: boolean;
  config_failed: boolean;
  e_607: boolean;
  e_610: boolean;
  e_611: boolean;
  e_632: boolean;
  heartbeat_type: string | null;
  e_input: string | null;
  output: string | null;
  chat: boolean | null;
  msg_text: boolean | null;
  msg_conf: string | null;
  msg_broadcast: boolean | null;
  name_dropdown: string | null;
  configuration_message: ConfirmMessage | {};
  zone?: Zone;
}

export interface BeltMonitoringNodeListQuery {
  page: number;
  limit: number;
  standby: boolean;
  status: 'active' | 'inactive' | 'unacknowledged' | 'all';
  section_ids: number[];
  map_level?: number | null;
}

export interface BeltMonitoringNodeListResponse {
  current_page: number;
  items_per_page: number;
  pages: number;
  count: number;
  count_by_layer: MapCountByLayer[];
  total: {
    all: number;
    active: number;
    inactive: number;
    unacknowledged: number;
  };
  items: BeltMonitoringNode[];
}
